import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Language strings for UI components
 */
export const LANG_STRINGS = {
  en: {
    // Watch buttons
    watchNow: 'Watch Now',
    buyNow: 'Buy Now',
    buyAccess: 'Buy Access',
    resume: 'Resume',
    continueWatching: 'Continue Watching',
    watchAgain: 'Watch Again',
    learnMore: 'Learn More',
    
    // Watchlist
    addToMyList: 'Add to My List',
    removeFromMyList: 'Remove from My List',
    
    // Modal text
    moreInfo: 'More info',
    close: 'Close',
    
    // Error states
    unableToLoadContent: 'Unable to Load Content Details',
    errorLoadingContent: 'We\'re having trouble loading the details for this content. Please try again later.',
    
    // Episodes
    episodes: 'Episodes',
    noEpisodesAvailable: 'No episodes available',
    
    // Related content
    moreLikeThis: 'More Like This',
    
    // Empty states
    noFeaturedContent: 'No featured content available',
    noContentAvailable: 'No content available',
  },
  es: {
    // Watch buttons
    watchNow: 'Ver Ahora',
    buyNow: 'Comprar Ahora',
    buyAccess: 'Comprar Acceso',
    resume: 'Continuar',
    continueWatching: 'Seguir Viendo',
    watchAgain: 'Ver de Nuevo',
    learnMore: 'Más Información',
    
    // Watchlist
    addToMyList: 'Agregar a Mi Lista',
    removeFromMyList: 'Quitar de Mi Lista',
    
    // Modal text
    moreInfo: 'Más información',
    close: 'Cerrar',
    
    // Error states
    unableToLoadContent: 'No se Pudo Cargar el Contenido',
    errorLoadingContent: 'Estamos teniendo problemas para cargar los detalles de este contenido. Por favor, inténtalo de nuevo más tarde.',
    
    // Episodes
    episodes: 'Episodios',
    noEpisodesAvailable: 'No hay episodios disponibles',
    
    // Related content
    moreLikeThis: 'Más Como Esto',
    
    // Empty states
    noFeaturedContent: 'No hay contenido destacado disponible',
    noContentAvailable: 'No hay contenido disponible',
  }
};

/**
 * Custom hook to detect language from URL path
 * Returns 'es' for Spanish pages, 'en' for everything else
 */
export const useLanguage = () => {
  const location = useLocation();
  
  const language = useMemo(() => {
    const path = location.pathname.toLowerCase();
    // Spanish paths
    if (path === '/espanol' || path.startsWith('/espanol/') || 
        path === '/series' || path.startsWith('/series/')) {
      return 'es';
    }
    return 'en';
  }, [location.pathname]);
  
  const strings = LANG_STRINGS[language] || LANG_STRINGS.en;
  
  return { language, strings };
};

/**
 * Get language strings without using a hook (for non-component code)
 * @param {string} pathname - The current URL pathname
 * @returns {Object} Language strings object
 */
export const getLanguageStrings = (pathname) => {
  const path = pathname.toLowerCase();
  if (path === '/espanol' || path.startsWith('/espanol/') || 
      path === '/series' || path.startsWith('/series/')) {
    return { language: 'es', strings: LANG_STRINGS.es };
  }
  return { language: 'en', strings: LANG_STRINGS.en };
};

export default useLanguage;

